import { getColors } from '../../../utils';
const getStyles = () => {
    return {
        container: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '20px',
            alignSelf: 'stretch'
        },
        section: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '8px',
            alignSelf: 'stretch'
        },

        title: {
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            alignSelf: 'stretch'
        },
        popover: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            borderRadius: '16px',
            padding: 0,
            border: getColors().border,
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.10), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',

        }
    }
}
export default getStyles;